exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more-button__spinner,\n.more-button {\n  margin-top: 0.5rem; }\n\n.more-button {\n  background: #89c9ea;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  height: 2rem;\n  width: 100%; }\n", ""]);

// exports
